var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModeBleDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4247 13.123L17.0429 9.08652L11.3405 2.96582V11.0256L7.9768 7.66188L6.75 8.88863L10.9711 13.123L6.75 17.3573L7.9768 18.5841L11.3405 15.2204L11.4466 22.9658L17.2494 17.1594L13.4247 13.123ZM15.0208 9.09969L13.0686 11.052L13.0554 7.13418L15.0208 9.09969ZM13.0686 15.1939L15.0208 17.1462L13.0554 19.1117L13.0686 15.1939Z",
    fill: "#151C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeBleDark);
export default __webpack_public_path__ + "static/media/mode-ble-dark.7c13ccbbc01239e8effa9c513b9e5cba.svg";
export { ForwardRef as ReactComponent };